import {
    primaryLight,
    secondaryLight,
    buttonLight,
    primaryDark,
    secondaryDark,
    buttonDark,
    headerLight,
    headerDark,
} from "./Palletes";

export const lightTheme = {
    primary: primaryLight,
    secondary: secondaryLight,
    button: buttonLight,
    header: headerLight,
};

export const darkTheme = {
    primary: primaryDark,
    secondary: secondaryDark,
    button: buttonDark,
    header: headerDark,
};
